"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const system_1 = require("@mui/system");
const react_1 = __importStar(require("react"));
const react_final_form_1 = require("react-final-form");
const components_1 = require("../../components");
const icons_1 = require("../../icons");
const required = (value) => (value ? undefined : 'Required');
const AcknowledgementForm = (props) => {
    const theme = (0, system_1.useTheme)();
    const { title, description, acknowledgements = [], finalAcknowledgement, handleCancel, handleSubmit, } = props;
    const [openDialogIdx, setOpenDialogIdx] = (0, react_1.useState)(null);
    const [acknowledgementList, setAcknowledgementList] = (0, react_1.useState)(Array(acknowledgements?.length).fill(false) || []);
    const onSubmit = async () => {
        await handleSubmit();
    };
    const handleAcknowledge = (idx) => {
        setAcknowledgementList((prevState) => {
            const newState = [...prevState];
            newState[idx] = true;
            return newState;
        });
        setOpenDialogIdx(null);
    };
    const hasAcknowledgedAll = acknowledgements?.length > 0
        ? acknowledgementList?.every((acknowledgement) => acknowledgement === true)
        : true;
    const renderAcknowledgements = () => {
        return acknowledgements?.map(({ title, dialogContent }, idx) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(components_1.ListItem, null,
                    react_1.default.createElement(components_1.ListItemButton, { onClick: () => setOpenDialogIdx(idx), disabled: acknowledgementList[idx] },
                        react_1.default.createElement(components_1.ListItemIcon, null,
                            react_1.default.createElement(icons_1.CheckCircleSolid, { color: acknowledgementList[idx] ? 'primary' : 'disabled', fontSize: "40px" })),
                        react_1.default.createElement(components_1.ListItemText, { primary: title }),
                        react_1.default.createElement(icons_1.ChevronRight, null))),
                react_1.default.createElement(components_1.Box, { sx: {
                        borderBottom: idx !== acknowledgements.length - 1
                            ? `solid 1px ${theme.palette.grey[300]}`
                            : 'none',
                    } }),
                react_1.default.createElement(components_1.Dialog, { title: title, open: openDialogIdx === idx, onClose: () => setOpenDialogIdx(null) },
                    react_1.default.createElement(components_1.Box, { margin: 2 },
                        react_1.default.createElement(react_final_form_1.Form, { onSubmit: () => { } }, ({ invalid }) => (react_1.default.createElement(components_1.Grid, { container: true, display: "flex", flexDirection: "column" },
                            dialogContent,
                            react_1.default.createElement(components_1.Grid, { item: true, mt: 2 },
                                react_1.default.createElement(components_1.Box, { display: "flex", width: "100%" },
                                    react_1.default.createElement(components_1.Box, { ml: "auto" },
                                        react_1.default.createElement(components_1.Button, { disabled: invalid, onClick: () => handleAcknowledge(idx), variant: "contained" }, "Acknowledge")))))))))));
        });
    };
    return (react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmit }, ({ handleSubmit, pristine, invalid, submitting }) => (react_1.default.createElement("form", { onSubmit: handleSubmit },
        react_1.default.createElement(components_1.Typography, { variant: "h5", mt: 2, mb: 2 }, title),
        react_1.default.createElement(components_1.Grid, { container: true, spacing: 2, display: "flex", flexDirection: "column" },
            description,
            acknowledgements.length > 0 && (react_1.default.createElement(components_1.Grid, { item: true },
                react_1.default.createElement(components_1.List, null, renderAcknowledgements()))),
            react_1.default.createElement(components_1.Grid, { item: true },
                react_1.default.createElement(react_final_form_1.Field, { name: "finalAcknowledgement", type: "checkbox", validate: required }, ({ input }) => (react_1.default.createElement(components_1.FormControlLabel, { sx: { display: 'flex', alignItems: 'start' }, key: input.value, control: react_1.default.createElement(components_1.Checkbox, { checked: input.value, onChange: input.onChange }), label: react_1.default.createElement(components_1.Box, { mt: 1 }, finalAcknowledgement) })))),
            react_1.default.createElement(components_1.Box, { ml: "auto", mt: 1 },
                react_1.default.createElement(components_1.Grid, { container: true, spacing: 2 },
                    react_1.default.createElement(components_1.Grid, { item: true },
                        react_1.default.createElement(components_1.Button, { variant: "outlined", color: "primary", onClick: handleCancel, disabled: submitting }, "Cancel")),
                    react_1.default.createElement(components_1.Grid, { item: true },
                        react_1.default.createElement(components_1.Button, { variant: "contained", color: "primary", type: "submit", onClick: handleSubmit, disabled: pristine || invalid || submitting || !hasAcknowledgedAll }, "Submit")))))))));
};
exports.default = AcknowledgementForm;
